import { useState } from "react";
import api from "../../utils/api";
import UploadImage from "../UploadImage";
import { HiTrash } from "react-icons/hi";

export default function AddPayout({ contentOwnerId, onSuccess }) {
  const [paidAt, setPaidAt] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [note, setNote] = useState("");
  const [images, setImages] = useState([{ file: null, preview: null }]);
  const [loading, setLoading] = useState(false);

  const addImageRow = () =>
    setImages([...images, { file: null, preview: null }]);
  const removeImageRow = (index) => {
    if (images.length === 1) return;
    setImages(images.filter((_, i) => i !== index));
  };
  const handleImageSelect = (index, file) => {
    const updated = [...images];
    updated[index] = { file, preview: URL.createObjectURL(file) };
    setImages(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!paidAt || !amount) {
      alert("Date and amount are required.");
      return;
    }

    if (images.some((img) => !img.file)) {
      alert("Please upload at least one payout record image.");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("paidAt", paidAt);
      formData.append("amount", parseFloat(amount));
      formData.append("paymentMethod", paymentMethod);
      formData.append("note", note);
      formData.append("contentOwnerId", contentOwnerId);
      images.forEach((img) => formData.append("payoutImageUrl", img.file));

      await api.post("/payouts", formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Payout added successfully!");
      setPaidAt("");
      setAmount("");
      setPaymentMethod("Bank Transfer");
      setNote("");
      setImages([{ file: null, preview: null }]);

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Add Payout</h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment Date
        </label>
        <input
          type="date"
          value={paidAt}
          onChange={(e) => setPaidAt(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payout Amount
        </label>
        <input
          type="text"
          placeholder="0.00"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment Method
        </label>
        <select
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled selected>
            Select Payment
          </option>
          <option value="KBZ Bank">KBZ Bank</option>
          <option value="AYA Bank">AYA Bank</option>
          <option value="CB Bank">CB Bank</option>
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Note (Optional)
        </label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Add any notes about this payout..."
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          rows="3"
        />
      </div>

      <div className="mb-6 space-y-4">
        <label className="block text-sm font-medium text-gray-600">
          Payout Records (Images)
        </label>
        {images.map((img, index) => (
          <div key={index} className="flex items-center gap-3">
            <UploadImage
              onFileSelect={(file) => handleImageSelect(index, file)}
              preview={img.preview}
            />
            {images.length > 1 && (
              <button
                type="button"
                onClick={() => removeImageRow(index)}
                className="text-red-500 hover:text-red-700"
              >
                <HiTrash className="w-5 h-5" />
              </button>
            )}
          </div>
        ))}
        <button
          type="button"
          onClick={addImageRow}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          + Add another image
        </button>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full rounded-lg bg-green-500 py-2.5 text-white font-medium
               hover:bg-green-700 transition"
      >
        {loading ? "Adding..." : "Add Payout"}
      </button>
    </form>
  );
}
